import { ChatBubbleOutline, ReplyOutlined, ThumbUpOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { formatCount } from "./marketingFormat";

const ELIGIBILITY = {
  ELIGIBLE: {
    label: "Can be boosted",
    tone: "bg-app-status-completed-bg text-app-status-completed-text",
  },
  INELIGIBLE: {
    label: "Cannot be boosted",
    tone: "bg-app-status-cancelled-bg text-app-status-cancelled-text",
  },
  UNKNOWN: {
    label: "Eligibility unconfirmed",
    tone: "bg-app-status-pending-bg text-app-status-pending-text",
  },
};

function Metric({ icon, value, label }) {
  if (value == null) return null;
  return (
    <span className="inline-flex items-center gap-1" title={label}>
      {icon}
      <span aria-label={label}>{formatCount(value)}</span>
    </span>
  );
}

export default function PostCard({ post, canBoost, onBoost, onOpenBoost }) {
  const eligibility = ELIGIBILITY[post.eligibility] || ELIGIBILITY.UNKNOWN;
  const published = post.publishedAt ? new Date(post.publishedAt) : null;
  return (
    <article className="flex flex-col overflow-hidden rounded border border-app-border bg-app-surface">
      {post.imageUrl ? (
        <img
          src={post.imageUrl}
          alt=""
          loading="lazy"
          className="h-40 w-full bg-app-surface-muted object-cover"
        />
      ) : (
        <div className="flex h-40 items-center justify-center bg-app-surface-muted text-sm text-app-text-muted">
          No image
        </div>
      )}
      <div className="flex flex-1 flex-col gap-2 p-3">
        <p className="line-clamp-3 min-h-[3.75rem] text-sm text-app-text">
          {post.text || "No caption"}
        </p>
        <div className="flex flex-wrap items-center gap-3 text-xs text-app-text-secondary">
          <Metric
            icon={<ThumbUpOutlined fontSize="inherit" />}
            value={post.reactions}
            label="Reactions"
          />
          <Metric
            icon={<ChatBubbleOutline fontSize="inherit" />}
            value={post.comments}
            label="Comments"
          />
          <Metric icon={<ReplyOutlined fontSize="inherit" />} value={post.shares} label="Shares" />
          {published && !Number.isNaN(published.getTime()) ? (
            <span className="ml-auto">{published.toLocaleDateString("en-AU")}</span>
          ) : null}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${eligibility.tone}`}>
            {eligibility.label}
          </span>
          {post.boostedCampaignId ? (
            <button
              type="button"
              className="text-xs text-app-primary hover:underline"
              onClick={() => onOpenBoost(post.boostedCampaignId)}
            >
              Boosted ({post.boostedStatus === "ACTIVE" ? "running" : "paused"})
            </button>
          ) : null}
        </div>
        <div className="mt-auto flex items-center gap-2 pt-1">
          {canBoost ? (
            <Button
              size="small"
              variant="contained"
              disabled={post.eligibility === "INELIGIBLE"}
              onClick={() => onBoost(post)}
            >
              Boost
            </Button>
          ) : null}
          {post.permalink ? (
            <Button size="small" href={post.permalink} target="_blank" rel="noopener noreferrer">
              View post
            </Button>
          ) : null}
        </div>
      </div>
    </article>
  );
}
